import React, { useMemo } from "react";
import styles from "./Cart.module.css";
import { ICartPagePlaceHolderProps } from "@model/Cart.model";
import CartItemPlaceholder from "./CartItemPlaceholder";

const CartPagePlaceholder: React.FC<ICartPagePlaceHolderProps> = ({
  title = "My Cart",
  isLoading = true,
  placeholderCount = 5,
  showTitle = true,
}) => {
  const count = Math.max(0, Number.isFinite(placeholderCount!) ? placeholderCount! : 0);
  const placeholders = useMemo(() => Array.from({ length: count }), [count]);

  return (
    <div className={styles.PlaceholderPage} data-testid="cart-page">
      <div className={styles.PlaceholderCart} data-testid="cart-container">
        <div className={styles.PlaceholderHeader} data-testid="cart-header">
          {showTitle && <h2 data-testid="cart-title">{title}</h2>}
          {isLoading && (
            <span
              className={`${styles.PlaceholderLoadingBar} ${styles.PlaceholderSkeleton}`}
              data-testid="cart-loading"
            />
          )}
        </div>

        <div className={styles.PlaceholderItems} data-testid="cart-items">
          {placeholders.map((_, idx) => (
            <CartItemPlaceholder key={idx} index={idx} />
          ))}
        </div>

        <div className={styles.PlaceholderFooter} data-testid="cart-footer">
          <div
            className={`${styles.PlaceholderCheckoutBtn} ${styles.PlaceholderSkeleton}`}
            data-testid="cart-checkout-btn"
          />
        </div>
      </div>
    </div>
  );
};

export default CartPagePlaceholder;
